export const MEMBERSHIP_STATUS = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  SUSPENDED: 'SUSPENDED',
  DELAYED: 'DELAYED'
}
